import { DepartmentFieldAccess, DepartmentFormDefaults } from "./departmentFields";
import type { CargoLine, DepartmentConfig, FormState } from "./types";

let lineIdCounter = 0;

export function makeCargoLine(): CargoLine {
  return {
    id: lineIdCounter++,
    type: "euro",
    sizeMode: "dimensions",
    length: "",
    width: "",
    qty: "",
    height: "",
    ldm: "",
    stack: false,
  };
}

export function toISODate(d: Date): string {
  return (
    d.getFullYear() +
    "-" +
    String(d.getMonth() + 1).padStart(2, "0") +
    "-" +
    String(d.getDate()).padStart(2, "0")
  );
}

export function todayISODate(): string {
  return toISODate(new Date());
}

export function makeInitialState(config?: DepartmentConfig): FormState {
  lineIdCounter = 0;
  const state: FormState = {
    loadCountry: "",
    loadPostal: "",
    loadCity: "",
    loadStreet: "",
    loadHouseNumber: "",
    unloadCountry: "",
    unloadPostal: "",
    unloadCity: "",
    unloadStreet: "",
    unloadHouseNumber: "",
    cargo: [makeCargoLine()],
    totalWeight: "",
    pickupDate: "",
    unloadDate: "",
    goods: "",
    adr: { active: false, adrClass: "", un: "" },
    temp: { active: false, min: "", max: "" },
    tail: { active: false, load: false, unload: false },
    ftl: { active: false },
    time: {
      active: false,
      deliveryDate: "",
      loadType: "window",
      loadFrom: "",
      loadUntil: "",
      loadFixed: "",
      unloadType: "window",
      unloadFrom: "",
      unloadUntil: "",
      unloadFixed: "",
    },
    ref: { active: false, reference: "", loadReference: "", unloadReference: "", notes: "" },
    attachments: { active: false, files: [] },
    contactName: "",
    company: "",
    email: "",
    phone: "",
    comment: "",
    privacyConsent: false,
  };
  if (!config) return state;
  return new DepartmentFormDefaults(new DepartmentFieldAccess(config)).apply(state);
}
